




















































import { Component, Prop, Vue } from "vue-property-decorator";
import CheckboxGroupBoolean from "../CheckboxGroupBoolean.vue";
import CardRiwayatPenyakitTerdahulu from "@/components/pemeriksaan/rpd/CardRiwayatPenyakitTerdahulu.vue";
import {
  KELUHAN_UTAMA_ITEMS,
  KELUHAN_UTAMA_LEGACY_ITEMS
} from "@/constants/geriatriOptions";
import { AsesmenGeriatriContent } from "@/types/asesmen_geriatri";

@Component({ components: { CheckboxGroupBoolean, CardRiwayatPenyakitTerdahulu } })
export default class SectionAnamnesisMedis extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: AsesmenGeriatriContent["anamnesis"];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop() readonly register!: number | string;
  @Prop() readonly rm!: number | string;
  @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;

  keluhanItems = KELUHAN_UTAMA_ITEMS;

  get keluhanLegacyTerisi(): string[] {
    const src = (this.value && this.value.keluhan_utama) || {};
    return KELUHAN_UTAMA_LEGACY_ITEMS.filter(
      item => (src as any)[item.key]
    ).map(item => item.label);
  }
}
